import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
const CoverLoading = () => {
    return (
        <div className='cover-loading'>
            <Box sx={{ display: 'flex' }}>
                <CircularProgress color='success' size={100}/>
            </Box>
        </div>
    );
};

export default CoverLoading;